import Header from "../components/Header";
import Footer from "../components/Footer";
import { Outlet, useNavigate } from "react-router-dom";
import useTokenVerifier from "../context/useTokenVerifier";
import { useEffect } from "react";
import jwt_decode from "jwt-decode";
import { useAuth } from "../context/AuthContext";
import AnalyticsTracker from "../routes/AnalyticsTracker";

export default function MainLayout() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const updateActivity = () => {
      localStorage.setItem("lastActivity", Date.now().toString());
    };

    document.addEventListener("mousemove", updateActivity);
    document.addEventListener("keydown", updateActivity);
    updateActivity();

    return () => {
      document.removeEventListener("mousemove", updateActivity);
      document.removeEventListener("keydown", updateActivity);
    };
  }, []);

  useEffect(() => {
    const accessToken = localStorage.getItem("access_token");
    if (accessToken) {
      try {
        const decoded: any = jwt_decode(accessToken);
        const nowSeconds = Date.now() / 1000;
        if (decoded.exp < nowSeconds) {
          logout();
          navigate("/login");
        }
      } catch {
        logout();
        navigate("/login");
      }
    }
  }, []);

  useTokenVerifier();
  return (
    <div className="flex flex-col min-h-screen bg-slate-100">
      <AnalyticsTracker />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}